let Data = {
  measurementData: [
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-h-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-h-n.png'),
      name: '高度测量',
      events: 'Elevation',
    },
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-d-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-d-n.png'),
      name: '距离测量',
      events: 'Lenth',
    },
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-m-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-m-n.png'),
      name: '面积测量',
      events: 'Area',
    },
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-a-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-a-n.png'),
      name: '角度测量',
      events: 'Angle',
    },
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-l-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-l-n.png'),
      name: '等高线',
      // 这个不清楚
      events: 'height',
    },
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-t-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-t-n.png'),
      name: '天际线',
      events: 'SkyLine_Real',
    },
    {
      iconA: require('@/assets/images/ueModel/measurement/icon-s-v.png'),
      iconN: require('@/assets/images/ueModel/measurement/icon-s-n.png'),
      name: '视域分析',
      events: 'CreateField',
      eventsBreak: 'DestroyField',
    },
  ],
  pageData: [
    {
      name: '园区介绍',
      camera: {
        Location: {
          X: 23517.356468,
          Y: -27894.768547,
          Z: 4888.593624,
        },
        Rotation: {
          Pitch: 1.682313,
          Yaw: 133.752033,
          Roll: 0.0,
        },
        Time: 1.5,
      },
    },
    {
      name: '综合态势',
      camera: {
        Location: {
          X: 23517.356468,
          Y: -27894.768547,
          Z: 4888.593624,
        },
        Rotation: {
          Pitch: 1.682313,
          Yaw: 133.752033,
          Roll: 0.0,
        },
        Time: 1.5,
      },
    },
    {
      name: '产业优势',
      camera: {
        Location: {
          X: 23517.356468,
          Y: -27894.768547,
          Z: 4888.593624,
        },
        Rotation: {
          Pitch: 1.682313,
          Yaw: 133.752033,
          Roll: 0.0,
        },
        Time: 1.5,
      },
    },
    {
      name: '运营态势',
      camera: {
        Location: {
          X: 23517.356468,
          Y: -27894.768547,
          Z: 4888.593624,
        },
        Rotation: {
          Pitch: 1.682313,
          Yaw: 133.752033,
          Roll: 0.0,
        },
        Time: 1.5,
      },
    },
    {
      name: '安全态势',
      camera: {
        Location: {
          X: 23517.356468,
          Y: -27894.768547,
          Z: 4888.593624,
        },
        Rotation: {
          Pitch: 1.682313,
          Yaw: 133.752033,
          Roll: 0.0,
        },
        Time: 1.5,
      },
    },
    {
      name: '运维态势',
      camera: {
        Location: {
          X: 23517.356468,
          Y: -27894.768547,
          Z: 4888.593624,
        },
        Rotation: {
          Pitch: 1.682313,
          Yaw: 133.752033,
          Roll: 0.0,
        },
        Time: 1.5,
      },
    },
  ],
  flyCamera: {
    Location: {
      X: 31271.51009,
      Y: -5288.016116,
      Z: 33649.802143,
    },
    Rotation: {
      Pitch: -42.020714,
      Yaw: 179.214349,
      Roll: 0.0,
    },
    Time: 1.5,
  },
  lowCamera: {
    Location: {
      X: 20536.531314,
      Y: -7876.829884,
      Z: 1831.658793,
    },
    Rotation: {
      Pitch: 4.634397,
      Yaw: 177.932304,
      Roll: 0.0,
    },
    Time: 1.5,
  },
  eventCamera: {
    monitor: {
      Location: {
        X: 28131.796898,
        Y: 148559.659956,
        Z: 55254.818034,
      },
      Rotation: {
        Pitch: -29.578774,
        Yaw: -90.635713,
        Roll: 0.0,
      },
    },
    door: {
      Location: {
        X: 28222.35164,
        Y: -6821.033561,
        Z: 35623.087261,
      },
      Rotation: {
        Pitch: -48.747145,
        Yaw: 178.298925,
        Roll: 0.0,
      },
    },
    camp: {
      Location: {
        X: 24890.274934,
        Y: -26371.058524,
        Z: 35623.087261,
      },
      Rotation: {
        Pitch: -50.127593,
        Yaw: 133.91462,
        Roll: 0.0,
      },
    },
    person: {
      Location: {
        X: 28222.35164,
        Y: -6821.033561,
        Z: 35623.087261,
      },
      Rotation: {
        Pitch: -48.747145,
        Yaw: 178.298925,
        Roll: 0.0,
      },
    },
    startOperation: {
      Location: {
        X: 37137.442635,
        Y: -75738.15513,
        Z: 62833.336593,
      },
      Rotation: {
        Pitch: -18.541862,
        Yaw: 101.031591,
        Roll: 0.0,
      },
    },
    buildInfomation: {
      Location: {
        X: 34420.480775,
        Y: -5409.060443,
        Z: 32280.289102,
      },
      Rotation: {
        Pitch: -37.723247,
        Yaw: 179.698785,
        Roll: 0.0,
      },
    },
    floorCamera: {
      Location: {
        X: 21685.971626,
        Y: -3029.409242,
        Z: 15713.062814,
      },
      Rotation: {
        Pitch: -28.649973,
        Yaw: -133.216831,
        Roll: 0.0,
      },
    },
  },
};

export { Data };
